import { useQuery } from 'react-query'
import { getIdents, getIdentByUrl, getIdentByCode } from 'services/requests/idents'
import { useGetResourcesByUrlArray } from './base'
import { Voice } from 'types/Voice'


export const useGetIdents = (params) => {
	const defaultParams = {
		page: 1,
		itemsPerPage: 30
	}

	return useQuery(
		['idents', {...defaultParams, ...params}],
		() => getIdents({...defaultParams, ...params})
	)
}

export const useGetIdentByUrlArray = ( voices ) => {
	return useGetResourcesByUrlArray<Voice>(getIdentByUrl, voices)
}

export const useGetIdentByCode = ( code ) => {
	return useQuery(['ident', code],() => getIdentByCode(code))
}
